import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { takeWhile } from "rxjs/operators";

import {
  PagingInfo
} from "src/app/shared/vo";

import {
  FvmsApiAuthService,
  FvmsApiDtgDriveSafeEcoService,
  FvmsCommonService,
  FvmsExcelService
} from "src/app/shared/service";

import {
  FilterDateDiff
  ,FilterDist
  ,FilterSecToTime
} from "src/app/shared/filter";

import addDays from "date-fns/addDays";
import {format} from "date-fns";
import {DecimalPipe} from "@angular/common";


@Component({
  selector: 'dtg-analytics-drive-carbon-list',
  templateUrl: './dtg.analytics.drive.carbon.list.component.html',
  providers: [FilterDateDiff,FilterDist,FilterSecToTime,DecimalPipe]
})
export class DtgAnalyticsDriveCarbonListComponent implements OnInit, OnDestroy {
  isContinue:boolean = true;
  companyInfo:any;
  currentUserInfo:any;
  userGroupId:number;
  dtgTeamId:string = "";
  pagingInfo:PagingInfo = new PagingInfo();
  excelPagingInfo:PagingInfo = new PagingInfo();

  listItem:any[] = [];
  listYear:number[] = [];
  listMonth:number[] = [];

  selectedYear:number = 2020;
  selectedMonth:number = 0;
  selectedDate:any;
  searchValue:string = "";

  pointSafeMin:any;
  pointSafeMax:any;

  //@Input() listType:DtgListType = DtgListType.list;

  constructor(
    private fvmsCommonService: FvmsCommonService
    ,private fvmsExcelService:FvmsExcelService
    ,private fvmsApiDtgDriveSafeEcoService:FvmsApiDtgDriveSafeEcoService
    ,private fvmsApiAuthService:FvmsApiAuthService
    //,private filterDateDiff:FilterDateDiff
    ,private filterSecToTime:FilterSecToTime
    ,private filterDist:FilterDist
  ) {
    this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
    this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
    if(this.userGroupId > 100){
      this.dtgTeamId = this.currentUserInfo.teamId;
    }
    this.companyInfo = this.fvmsCommonService.getCompanyInfo();
    let dateTimeInfo = this.fvmsCommonService.getDateInfo();
    this.excelPagingInfo.pageSize = 60*60*24;

    for(let a=2020;a<2100;a++){
      this.listYear.push(a);
    }
    for(let a=1;a<13;a++){
      this.listMonth.push(a);
    }

    let tmpDateInfo = this.fvmsCommonService.getDateInfo();
    if(tmpDateInfo && tmpDateInfo.fromDate){
      this.selectedYear = tmpDateInfo.fromDate.year;
      this.selectedMonth = tmpDateInfo.fromDate.month;
    }else{
      let today = new Date();
      this.selectedYear = today.getFullYear();
      this.selectedMonth = today.getMonth() + 1;
    }

    this.fvmsCommonService.subscribeCompanyInfo()
      .pipe(takeWhile(() => this.isContinue))
      .subscribe(companyInfo => {
        this.pagingInfo.curPage = 1;
        this.pagingInfo.pageSize = 20;
        this.companyInfo = companyInfo;
        this.changeDate();
        this.reloadListItem();
        //this.reloadListSum();
      });

  }

  ngOnInit(): void {
    this.changeDate();
    this.reloadListItem();
    //this.reloadListSum();
  }

  ngOnDestroy() {
    this.isContinue = false;
  }

  changeDate() {
    let dtFrom = new Date(this.selectedYear, this.selectedMonth - 1, 1, 0, 0, 0, 0);
    let dtTo = new Date(this.selectedYear, this.selectedMonth, 1, 0, 0, 0, 0);
    dtTo = addDays(dtTo, -1);
    let searchDateFrom = format(dtFrom, "yyyy-MM-dd 00:00:00");
    let searchDateTo = format(dtTo, "yyyy-MM-dd 23:59:59");
    this.selectedDate = {
      searchDateFrom: searchDateFrom
      , searchDateTo: searchDateTo
    };
  }

  clickSearch(){
    this.pagingInfo.curPage = 1;
    this.pagingInfo.pageSize = 20;
    this.reloadListItem();
    //this.reloadListSum();
  }

  //https://patentimages.storage.googleapis.com/9f/53/ed/37541ca9d0c36d/KR101803662B1.pdf
  // 100-97 : 매우안전
  //  96-93 : 안전
  //  92-89 : 보통
  //  88-85 : 위험
  //  84-74 : 매우위험
  calcDrivePoint(item) {
    if (item) {
      if (item.dtgDistAccumul === 0) {
        item.pointSafe = 0;
        item.cntRulePer100 = 0;
        return;
      }
      let dist = (item.dtgDistAccumul * 0.001 || 1);//운행거리 km 단위로 변경
      let cntRule1Per100 = ((item.cntRule1 * 100) / dist);//100km당 횟수
      let cntRule2Per100 = ((item.cntRule2 * 100) / dist);
      let cntRule3Per100 = ((item.cntRule3 * 100) / dist);
      let cntRule4Per100 = ((item.cntRule4 * 100) / dist);
      let cntRule5Per100 = ((item.cntRule5 * 100) / dist);
      let cntRule6Per100 = ((item.cntRule6 * 100) / dist);
      let cntRule7Per100 = ((item.cntRule7 * 100) / dist);
      let cntRule8Per100 = ((item.cntRule8 * 100) / dist);
      let cntRule9Per100 = ((item.cntRule9 * 100) / dist);
      let cntRule10Per100 = ((item.cntRule10 * 100) / dist);

      //안전운전지수 = 100키로당 횟수 * (기본 가중치 + 추가 가중치)
      let rule1DangerPt = cntRule1Per100 * (0.083 + 0.083);//과속
      let rule2DangerPt = cntRule2Per100 * (0.083 + 0.083);//장기과속
      let rule3DangerPt = cntRule3Per100 * (0.180 + 0.180);//급가속
      let rule4DangerPt = cntRule4Per100 * (0.180 + 0.180);//급출발
      let rule5DangerPt = cntRule5Per100 * (0.264 + 0.264);//급감속
      let rule6DangerPt = cntRule6Per100 * (0.264 + 0.264);//급정지
      let rule7DangerPt = cntRule7Per100 * (0.245 + 0.245);//급진로변경
      let rule8DangerPt = cntRule8Per100 * (0.245 + 0.245);//급앞지르기
      let rule9DangerPt = cntRule9Per100 * (0.228 + 0.228);//급좌우회전
      let rule10DangerPt = cntRule10Per100 * (0.228 + 0.228);//급유턴

      //100키로당 횟수
      item.cntRule1Per100 = cntRule1Per100;
      item.cntRule2Per100 = cntRule2Per100;
      item.cntRule3Per100 = cntRule3Per100;
      item.cntRule4Per100 = cntRule4Per100;
      item.cntRule5Per100 = cntRule5Per100;
      item.cntRule6Per100 = cntRule6Per100;
      item.cntRule7Per100 = cntRule7Per100;
      item.cntRule8Per100 = cntRule8Per100;
      item.cntRule9Per100 = cntRule9Per100;
      item.cntRule10Per100 = cntRule10Per100;

      //안전운전지수
      item.rule1DangerPt = rule1DangerPt;
      item.rule2DangerPt = rule2DangerPt;
      item.rule3DangerPt = rule3DangerPt;
      item.rule4DangerPt = rule4DangerPt;
      item.rule5DangerPt = rule5DangerPt;
      item.rule6DangerPt = rule6DangerPt;
      item.rule7DangerPt = rule7DangerPt;
      item.rule8DangerPt = rule8DangerPt;
      item.rule9DangerPt = rule9DangerPt;
      item.rule10DangerPt = rule10DangerPt;

      //100키로당 횟수 합산
      let sumCntPer100 = cntRule1Per100 + cntRule2Per100 + cntRule3Per100 + cntRule4Per100 + cntRule5Per100;
      sumCntPer100 += cntRule6Per100 + cntRule7Per100 + cntRule8Per100 + cntRule9Per100 + cntRule10Per100;

      //안전운전지수 합산
      let sumDangerPt = rule1DangerPt + rule2DangerPt + rule3DangerPt + rule4DangerPt + rule5DangerPt;
      sumDangerPt += rule6DangerPt + rule7DangerPt + rule8DangerPt + rule9DangerPt + rule10DangerPt;


      //100키로당 횟수 합산
      item.cntRulePer100 = sumCntPer100;

      //안전운전지수
      item.pointSafe = 100 - sumDangerPt;
      item.pointSafe = Number( item.pointSafe.toFixed(1) );
    }
  }
  calcCarbonemissions(item){
      // item.carbonEmissions = item.dtgOilUseAccumul * 35.40 * 74100.00 * 0.001 * 1 / item.dtgDistAccumul;
      // item.carbonEmissions = Number( item.carbonEmissions.toFixed(5) );
      item.carbonEmissions = item.dtgOilUseAccumul * 35.3 * 20.09 * 0.001 / 1000000;
  }

  getSearchInfo(){
    let dtFrom = new Date(this.selectedYear,this.selectedMonth - 1,1,0,0,0,0);
    let dtTo = new Date(this.selectedYear,this.selectedMonth,1,0,0,0,0);
    dtTo = addDays(dtTo,-1);
    let searchDateFrom = format(dtFrom,"yyyy-MM-dd 00:00:00");
    let searchDateTo = format(dtTo,"yyyy-MM-dd 23:59:59");
    let searchInfo = {
      companyId:this.companyInfo?.companyId || 0
      ,dtgTeamId:this.currentUserInfo?.teamId || ""
      ,searchDateFrom:searchDateFrom
      ,searchDateTo:searchDateTo
      ,searchValue:this.searchValue
      ,dtgGroupByUnitId:"Y"
      ,dtgGroupByRegDtMm:"Y"
      ,dtgGroupByRegDtYy:"Y"
    };
    return searchInfo;
  }

  reloadListItem() {
    this.fvmsCommonService.setIsLoading(true);
    this.fvmsApiDtgDriveSafeEcoService.getListReportSafeDriving(this.getSearchInfo(), this.pagingInfo)
      .pipe(takeWhile(() => this.isContinue))
      .subscribe(apiResponse => {
        this.listItem = [];
        this.pointSafeMin = null;
        this.pointSafeMax = null;

        if (apiResponse.resultStatus === "ok") {
          if (apiResponse.resultValue) {
            this.listItem = apiResponse.resultValue;
            this.pagingInfo = apiResponse.pagingInfo;
            let sizeList = this.listItem.length;
            for(let a=0;a<sizeList;a++) {
              let item = this.listItem[a];
              this.calcDrivePoint(item);
              this.calcCarbonemissions(item);
            }
          }
          this.pagingInfo = apiResponse.pagingInfo;
        }
        this.fvmsCommonService.setIsLoading(false);
      });
  }

  // 기능
  //검색어 입력란에 엔터키 누르면 실행
  keyupEnterSearchValue(e){
    this.changeDate();
    this.clickSearch();
  }

  changeYear(e){
    this.changeDate();
    //this.clickSearch();
  }

  changeMonth(e){
    this.changeDate();
    //this.clickSearch();
  }


  excelDownload() {
    // this.fvmsExcelService.excelDownload(this.convertExcelJson(this.listItem),"analytics-drive-safe-safety");
    this.fvmsCommonService.setIsLoading(true);

    this.fvmsApiDtgDriveSafeEcoService.getListReportSafeDriving(this.getSearchInfo(), this.excelPagingInfo)
      .pipe(takeWhile(() => this.isContinue))
      .subscribe(apiResponse => {
        this.listItem = [];
        this.pointSafeMin = null;
        this.pointSafeMax = null;

        if (apiResponse.resultStatus === "ok") {
          if (apiResponse.resultValue) {
            this.listItem = apiResponse.resultValue;
            this.pagingInfo = apiResponse.pagingInfo;
            let sizeList = this.listItem.length;
            for (let a = 0; a < sizeList; a++) {
              let item = this.listItem[a];
              this.calcDrivePoint(item);
              this.calcCarbonemissions(item);
            }

            this.fvmsExcelService.excelDownload(this.convertExcelJson(this.listItem), "analytics-drive-cabon");
          }
          this.pagingInfo = apiResponse.pagingInfo;
        }
        this.fvmsCommonService.setIsLoading(false);
      });

  }

  convertExcelJson(dataList: any[]) {
    let resultList = [];
    dataList.map((v) => {
      console.log(v);
      resultList.push({
        "소속회사": v.companyNm
        , "차량번호": v.dtgCarNo
        , "운행거리": this.filterDist.transform(Number(v.dtgDistAccumul))
        , "안전운전지수": v.pointSafe
        , "연료소모량": v.dtgOilUseAccumul
        , "탄소배출량": v.carbonEmissions
      })
    });
    return resultList;
  }

  callbackClickPageNumber(selectedPage: number) {
    this.pagingInfo.curPage = selectedPage;
    this.reloadListItem();
  }

  callbackChangeCountRowPerPage(pageSize: number) {
    this.pagingInfo.pageSize = pageSize;
    this.reloadListItem();
  }
}


